import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import tw from './locales/tw.json';
import gaa from './locales/gaa.json';
import ee from './locales/ee.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      tw: { translation: tw },
      gaa: { translation: gaa },
      ee: { translation: ee },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'tw', 'gaa', 'ee'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
